import crypto from "crypto"
import { twMerge } from "tailwind-merge"
import { ClassValue, clsx } from "clsx"
import { ProductPricesQuery } from "~/vendure/generated/graphql"

export { isTicketOrder } from "./is-ticket-order"

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}

export function roundToNearest(value: number, step: number) {
  return Math.round(value / step) * step
}

export function sliceProducts(products: any[], n: number) {
  let productsSet = []
  for (let i = 0; i < products.length; i += n) {
    productsSet.push(products.slice(i, i + n))
  }
  return productsSet
}

export function createETag(
  data: any,
  productPrices: ProductPricesQuery & { _headers: Headers }
) {
  const str = JSON.stringify(data)
  const hash = crypto.createHash("md5").update(str).digest("hex")
  return hash
}

// create a slow promise
export function slow(ms: number) {
  return (data: any) => {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(data)
      }, ms)
    })
  }
}

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
